module.exports = __webpack_public_path__ + "static/media/LK__Radio Button Check.158a3652.svg";